import React, { useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../Helpers/showToast";
import { SUPERGET, SUPERPOST } from '../Services/AxiosService';
import { CustomStringify } from "../Helpers/CustomStringify";
import Header from "../Components/Header/Header";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { fetchDataComp, removeCompanyDetail } from "../Redux/CompanyDetail/CompanyDetailSlice";
import { fetchDataUser, removeUserDetail } from "../Redux/UserDetail/UserDetailSlice";
import { fetchDataBarRate } from "../Redux/BarcodeRateSetting/BarcodeRateSettingSlice";
import { Backdrop, Box } from "@mui/material";

export default function RouteWrapper({ childComponent }) {
  const { cmpdetail, status, error } = useSelector(
    (state) => state.CompanyDetail
  );
  const userData = useSelector(
    (state) => state.UserDetail
  );

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = location?.pathname?.split("login/")[1];

  const paths = [
    "/CompanyDashboard",
    "/mnuAccount",
    "/mnuFGDesign",
    "/mnuFGDesign/AddFGDesign",
    "/mnuFGDesign/EditFGDesign",

    "/BiltyOutward",
    "/BiltyOutward/AddBiltyOutward",
    "/BiltyOutward/EditBiltyOutward",
    "/PackingChallan",
    "/PackingChallan/AddPackingChallan",
    "/PackingChallan/EditPackingChallan",

    "/StockReport",
    "/StockQuickSummary",
    "/StockSummary",
    "/StockDetail",
    "/PackingChallanReport",
    "/SaleReport",

    "/Settings",
  ];

  const InnerPath =
    paths?.filter((path) => {
      return location.pathname?.toLowerCase().includes(path?.toLowerCase());
    })?.length > 0;

  useEffect(() => {
    if (location?.pathname != "/" && !cmpdetail) {
      dispatch(fetchDataComp(token ? token : localStorage?.getItem("token")));
    }
  }, [location.pathname]);

  useEffect(() => {
      dispatch(fetchDataComp(token ? token : localStorage?.getItem("token")));
  }, [token ? token : localStorage?.getItem("token")]);

  const logout = () => {
    localStorage?.removeItem("token");
    localStorage?.removeItem("user");
    dispatch(removeCompanyDetail());
    dispatch(removeUserDetail());
    navigate(`/`);
  };

  const logout2 = () => {
    localStorage?.removeItem("token");
    localStorage?.removeItem("user");
    dispatch(removeUserDetail());
  };

  useEffect(() => {
    if (status == "succeeded" && cmpdetail && InnerPath) {
      let user = localStorage?.getItem("user");
      dispatch(fetchDataUser({ key: cmpdetail?.key, UserName: user?.split(":")[0], password: user?.split(":")[1] }))
    } else if (status == "failed") {
      // showToast("Request failed Please login again!", "error");
      logout();
    }
  }, [status])

  useEffect(() => {
    if (userData?.status == "succeeded") {
      dispatch(fetchDataBarRate(cmpdetail))
    } else if (userData?.status == "failed") {
      showToast(userData?.error, "error");
      logout2();
    }
  }, [userData?.status])


  return ((status == "idle" || status == "loading" || userData?.status == "idle" || userData?.status == "loading") && InnerPath) ? (
    <Backdrop
      sx={{
        color: "#000",
        bgcolor: "rgb(216, 227, 240)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
    >
      {/* <div className="dot-typing"></div> */}
      <div className="loader">
        <img src="/EasyTradeLoad.png" />
      </div>
    </Backdrop>
  ) : status != "failed" && userData?.status != "failed" && InnerPath ? (
    <>
      <div className="main-container">
        <Header />
        {childComponent}
        <Box sx={{ bgcolor: "#222831", color: "#fff", fontSize: "15px", width: "100vw", position: "absolute", bottom: 0.1, textAlign: "center", m: 0, p: 0.3, pb: 0.6 }}>
          <p style={{ margin: 0 }}><i>Powered by Concept Tek Solution</i></p>
        </Box>
      </div>
      <Toaster position="top-center" reverseOrder={false} />
    </>
  ) : (
    <>
      {childComponent}
      <Box sx={{ bgcolor: "#222831", color: "#fff", fontSize: "15px", width: "100vw", position: "absolute", bottom: 0.1, textAlign: "center", m: 0, p: 0.3, pb: 0.6 }}>
        <p style={{ margin: 0 }}><i>Powered by Concept Tek Solution</i></p>
      </Box>
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
